import React, { useEffect, useRef, useState } from "react";
import PartyDetails from "./partyDetails";
import Datagrid from "./datagrid";
import { useDispatch, useSelector } from "react-redux";
import { setAlertWithTitle, setSpinnerLoading } from "../utility/Redux/modal";
import { useFocus } from "../utility/hooks/hooks";
import { selectPrefix } from "../utility/Redux/profile";
import { selectToken } from "../utility/Redux/security";
import moment from "moment";
import CallAPI from "../utility/functions/getData";
import uniqueId from "uniqid";
import { useReactToPrint } from "react-to-print";
import AlertModalTwoButton from "../utility/component/modals/alertWithTwoButton";
import ItemMasterModal from "../masters/item-master/itemModal";
import PartyMasterCreaterModal from "../help/partyMasterCreaterModal";
import dataToLocal from "../utility/component/dataToLocal";
import deleteWholeDatabase from "../utility/functions/deleteWholeDatabase";
import IsLocalData from "../utility/component/isLocalData";
import BarcodeList from "./barCodeList";
import { CallAPIPromise } from "../billing/common";
import { emptyRowDetails, emtyRowDetailSAccountLedger } from "./fun";
import ListAccVoucherHelp from "../help/listAcc_VoucherHelp";
import { AccountMasterHelp } from "../help";
import VoucherEntryPrint from "../print/voucherEntryPrint";

const VoucherEntery = () => {
  const [itemMasterStatus, setItemMasterStatus] = useState(false);
  const [isClearForm, setIsClearForm] = useState(false);
  const [inputRef, setInputRefFoucs] = useFocus();
  const [partyNameRef, setPartyNameFocus] = useFocus();
  const [issueToRef, setIssueToRef] = useFocus();
  const [frieghtRef, setFrieghtFocus] = useFocus();
  const [barCodeListStatus, setBarCodeListStatus] = useState(false);
  const [barCodeList, setBarCodeList] = useState([]);
  const [voucherHelpStatus, setVoucherHelpStatus] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [rowId, setRowId] = useState("");
  const [vouhcerNo, setVoucherNo] = useState("");
  const [partyMasterCreaterModalStatus, setPartyMasterCreaterModalStatus] =
    useState(false);
  const [refreshList, setRefreshList] = useState(false);
  const handleClose = () => {
    setItemMasterStatus(false);
  };
  const printBarRef = useRef();

  const [alertTwoButtonModal, setAlertTwoButtonModal] = useState({
    title: "",
    msg: "",
    status: false,
    setStatus: "",
    button1: "",
    button1Click: "",
    button2: "",
    button2Click: "",
  });
  const defaultPartyDetails = {
    DATE: moment().format("YYYY-MM-DD"),
    VOUCHER_TYPE: "Purchase",
    DOC_NO: "",
    NARRATION: "",
  };
  const [partyDetails, setPartyDetails] = useState(defaultPartyDetails);

  const [currentINVNO, setCurrentINVNO] = useState("");
  const [rows, setRows] = useState([
    {
      ...emptyRowDetails,
      id: uniqueId(),
    },
  ]);

  const [accountMasterHelpStatus, setAccountMasterHelpStatus] = useState(false);

  const dispatch = useDispatch();
  const prefix = useSelector(selectPrefix);
  const token = useSelector(selectToken);

  const savePurchaseBill = () => {
    const updatedPartyDetails = rows.map((item) => {
      return {
        ...item,
        ENT_TIME: moment().format("HH:MM:SS"),
        VOUCHER_TYPE: partyDetails.VOUCHER_TYPE,
        DOC_NO: partyDetails.DOC_NO,
        NARRATION: partyDetails.NARRATION,
        DATE: moment().format("YYYY-MM-DD"),
        REMARKS: partyDetails.REMARKS,
      };
    });

    const filterData = updatedPartyDetails.filter(
      (item) => item.ACCOUNT_NO !== "" && item.ACCOUNT_NAME !== ""
    );

    if (
      partyDetails.VOUCHER_TYPE &&
      filterData.every((row) => row.ACCOUNT_NAME) &&
      filterData.every((row) => row.DEBIT > 0 || row.CREDIT > 0) &&
      filterData[0] &&
      partyDetails.NARRATION
    ) {
      setAlertTwoButtonModal((o) => {
        return {
          ...o,
          status: false,
        };
      });
      savePurchaseAfterCheck(
        prefix,
        filterData,
        partyDetails,
        dispatch,
        token,
        setVoucherNo,
        setAlertTwoButtonModal,
        clearState,

        handlePrint,
        setIsClearForm
      );
    } else {
      if (!partyDetails.VOUCHER_TYPE) {
        dispatch(
          setAlertWithTitle({
            title: "Alert",
            msg: "Please Select Voucher Type.",
          })
        );
      } else {
        if (!filterData[0]) {
          setAlertTwoButtonModal((o) => {
            return {
              ...o,
              title: "Alert",
              status: true,
              msg: "Not found any data to save.",
              button1: "Ok",
              button1Click: () => {
                delayedFunction(rows[0].id);
                setAlertTwoButtonModal((e) => {
                  return {
                    ...e,
                    status: false,
                  };
                });
              },
            };
          });
        } else {
          const itemsWithoutQuantity = filterData.filter(
            (row) => !row.DEBIT && !row.CREDIT
          );

          if (itemsWithoutQuantity.length > 0) {
            const itemNames = itemsWithoutQuantity
              .map((item) => item.ACCOUNT_NAME)
              .join(", ");
            setAlertTwoButtonModal({
              title: "Alert",
              msg: ` ${itemNames} item are missing quantity. Please enter Debit / Credit for that entry. `,

              status: true,
              button1: "Ok",
              button1Click: () => {
                setAlertTwoButtonModal((o) => {
                  return {
                    ...o,
                    status: false,
                  };
                });
              },
            });
          } else {
            if (!partyDetails.NARRATION) {
              dispatch(
                setAlertWithTitle({
                  title: "Narration",
                  msg: "Narration is required to save data",
                })
              );
            }
          }
        }
      }
    }
  };

  const delayedFunction = (id) => {
    setTimeout(() => {
      // Function to execute after 30 seconds
      const nearestInput = document.getElementById(id + "-" + "ACCOUNT_NO");
      if (nearestInput) {
        nearestInput.focus();
      }
    }, 200);
  };

  const clearState = () => {
    setRows([
      {
        ...emptyRowDetails,
        id: uniqueId(),
      },
    ]);

    setPartyDetails(defaultPartyDetails);
  };

  const printRef = useRef();
  const thermalPrintRef = useRef();
  const [selectedPrintOption, setSelectedPrintOption] = useState("print");

  const handlePrint = useReactToPrint({
    pageStyle: `
    @page {
      size: portrait;
    }
  `,
    content: () =>
      selectedPrintOption === "print"
        ? printRef.current
        : thermalPrintRef.current,
    onAfterPrint: () => {
      clearState();
    },
  });
  const handlePrint2 = useReactToPrint({
    pageStyle: `
    @page {
      size: portrait;
    }
  `,
    content: () =>
      selectedPrintOption === "print"
        ? printRef.current
        : thermalPrintRef.current,
    onAfterPrint: () => {
      // setAccountMasterHelpStatus(true);
      // setSelectedPrintOption("print");
    },
  });

  useEffect(() => {
    function handleKeyPress(event) {
      // Check if Ctrl or Alt key is pressed along with 'S'
      if ((event.ctrlKey || event.altKey) && event.key === "s") {
        event.preventDefault();
        savePurchaseBill();
      }
    }

    // Add event listener when component mounts
    window.addEventListener("keydown", handleKeyPress);

    // Remove event listener when component unmounts
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [partyDetails, rows]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.key === "1") {
        event.preventDefault();

        setPartyNameFocus();
        // Add your logic here
      }

      if (event.ctrlKey && event.key === "2") {
        event.preventDefault();
        delayedFunction(rows[0].id);
        // Add your logic here
      }

      if (event.ctrlKey && event.key === "3") {
        event.preventDefault();

        setFrieghtFocus();
        // Add your logic here
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    if (rows[0]?.ICODE && rows[0]?.ITEMNAME) {
      deleteWholeDatabase("voucher_entery").then(() => {
        dataToLocal("issue", rows, [
          {
            ...partyDetails,
            ICODE: 1,
          },
        ]);
      });
    }
  }, [rows]);

  useEffect(() => {
    const callback = (details, data) => {
      if (data[0]) {
        setAlertTwoButtonModal({
          title: "Unsaved Data",
          msg: "We found an unsaved Voucher. Do you want to load it?",
          status: true,
          button1: "Yes",
          button2: "Cancel",
          button1Click: () => {
            setPartyDetails(details[0]);
            setRows(data);
            setAlertTwoButtonModal((o) => {
              return {
                ...o,
                status: false,
              };
            });
          },

          button2Click: () => {
            deleteWholeDatabase("issue");
            setAlertTwoButtonModal((o) => {
              return {
                ...o,
                status: false,
              };
            });
          },
        });
      }
    };
    const elseFunc = () => {};
    IsLocalData("voucher_entery", callback, elseFunc);
  }, []);

  return (
    <div className=" px-3 py-2 bg-[#f9fafc] h-full text-black text-sm overflow-y-auto">
      <PartyDetails
        partyDetails={partyDetails}
        setPartyDetails={setPartyDetails}
        issueToRef={issueToRef}
        delayedFunction={delayedFunction}
        setVoucherHelpStatus={setVoucherHelpStatus}
        rows={rows}
      />
      <Datagrid
        delayedFunction={delayedFunction}
        savePurchaseBill={savePurchaseBill}
        inputRef={inputRef}
        setBarCodeListStatus={setBarCodeListStatus}
        setBarCodeList={setBarCodeList}
        setItemMasterStatus={setItemMasterStatus}
        partyDetails={partyDetails}
        setPartyDetails={setPartyDetails}
        setAccountMasterHelpStatus={setAccountMasterHelpStatus}
        rows={rows}
        accountMasterHelpStatus={accountMasterHelpStatus}
        setIsClearForm={setIsClearForm}
        setRows={setRows}
        currentINVNO={currentINVNO}
        clearState={clearState}
        handlePrint={handlePrint}
        handlePrint2={handlePrint2}
        alertTwoButtonModal={alertTwoButtonModal}
        setAlertTwoButtonModal={setAlertTwoButtonModal}
      />

      <AlertModalTwoButton
        details={alertTwoButtonModal}
        setAlertTwoButtonModal={setAlertTwoButtonModal}
      />
      <PartyMasterCreaterModal
        afterCreate={() => {
          setPartyMasterCreaterModalStatus(false);
          setRefreshList((o) => !o);
        }}
        status={partyMasterCreaterModalStatus}
        hidePartyList={true}
        onClose={() => {
          setPartyMasterCreaterModalStatus(false);
        }}
      />
      <VoucherEntryPrint
        IsVoucher={vouhcerNo}
        printRef={printRef}
        handlePrint={handlePrint}
      />
      <ListAccVoucherHelp
        onClose={() => {
          setVoucherHelpStatus(false);
        }}
        onRowClick={(p) => {
          CallAPIPromise("/api/Accounts/loadVoucher", {
            table_prefix: prefix,
            VOUCHER_NO: p.row.VOUCHER_NO,
          }).then((res) => {
            if (!res.data.error) {
              setRows([
                ...res.data.response.map((o) => {
                  return {
                    ...o,
                    CLEARANCE_DATE: moment(o.CLEARANCE_DATE).format(
                      "YYYY-MM-DD"
                    ),
                    INSTRUMENT_DATE: moment(o.INSTRUMENT_DATE).format(
                      "YYYY-MM-DD"
                    ),
                  };
                }),
                emptyRowDetails,
              ]);
              setPartyDetails({
                ...res.data.response[0],
              });
            }
          });
          setVoucherHelpStatus(false);
        }}
        status={voucherHelpStatus}
      />
      <BarcodeList
        status={barCodeListStatus}
        list={barCodeList}
        onClose={() => {
          setBarCodeListStatus(false);
        }}
        handleBillPrint={handlePrint}
        printBarRef={printBarRef}
      />
    </div>
  );
};

export default VoucherEntery;
function savePurchaseAfterCheck(
  prefix,
  filterData,
  partyDetails,
  dispatch,
  token,
  setCurrentINVNO,
  setAlertTwoButtonModal,
  clearState,
  handlePrint,
  setIsClearForm
) {
  const data = {
    table_prefix: prefix,
    voucher_master_cart: filterData.map(
      ({ OPENING_BALANCE, OPENING_BALANCE_TYPE, ...rest }) => rest
    ),
    NEW_MODIFY: filterData[0].SERIAL_NO ? "Modify" : "New",
  };
  partyDetails.SERIAL_NO
    ? dispatch(setSpinnerLoading("Updating"))
    : dispatch(setSpinnerLoading("Saving"));
  CallAPI(
    "/api/Accounts/saveVoucher",
    data,
    token,
    (e) => {
      if (!e.data.error) {
        deleteWholeDatabase("voucher_entery");
        setCurrentINVNO(e.data.VOUCHER_NO);
        localStorage.setItem("prev_narration", partyDetails.NARRATION);
        const VOUCHER_NO = e.data.VOUCHER_NO;
        setAlertTwoButtonModal((e) => {
          return {
            ...e,
            title: partyDetails.VOUCHER_NO
              ? `Invoice - ${partyDetails.VOUCHER_NO} `
              : `Invoice - ${VOUCHER_NO}`,
            msg: "Data Saved",
            status: true,
            button1: "Ok",
            button1Bg: "gray",

            button2Bg: "#34b4eb",
            button2: "Print",
            button1Click: () => {
              setAlertTwoButtonModal((e) => {
                return {
                  ...e,
                  status: false,
                };
              });

              clearState();
            },
            button2Click: () => {
              setAlertTwoButtonModal((e) => {
                return {
                  ...e,
                  status: false,
                };
              });
              setIsClearForm(true);
              handlePrint();
            },
          };
        });
      } else {
        dispatch(
          setAlertWithTitle({
            title: "Alert",
            msg: "Something Went Wrong.",
          })
        );
      }
    },
    dispatch,
    () => {
      dispatch(setSpinnerLoading(false));
    }
  );
}
